import script from "./LbrxPreviewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LbrxPreviewModal.vue?vue&type=script&setup=true&lang=ts"

import "./LbrxPreviewModal.vue?vue&type=style&index=0&id=633b45a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-633b45a5"]])

export default __exports__